import { Buffer } from 'buffer';

import { JWTData } from '../models/Auth';

export function parseJWT(): JWTData | undefined {
  try {
    const jwt = localStorage.getItem('auth');

    if (!jwt) {
      return undefined;
    }
    const tokens = JSON.parse(jwt);

    if (!tokens || !tokens['access_token']) {
      return undefined;
    }

    const decoded = Buffer.from(tokens['access_token'].split('.')[1], 'base64').toString('ascii');
    return JSON.parse(decoded);
  } catch {
    return undefined;
  }
}
